import React from 'react';
import { Text } from 'react-native';
import type { TDocumentsMonthTitleProps } from '../../types';

export const DocumentsMonthTitle = ({ title }: TDocumentsMonthTitleProps) => (
    <Text className="pb-sm pt-md text-md font-semibold uppercase tracking-[1.8px] text-gray-500">{title}</Text>
);
